<template>
    <div class="template_wrapper">
        <div class="template_title"><span style="color:red;vertical-align: top;" v-if="moduel.required==1" >*</span>{{moduel.name}}</div>
         <el-date-picker
            v-if="moduel.key_name == 'end_time'"
            v-model="key_name"
            type="date"
            placeholder="选择日期" :picker-options="pickerOptions_end_time" @change="time_form"
         >
           <template slot="prepend">{{moduel.name}}</template>
          </el-date-picker>

          <!-- <span style="color:red;" v-if="moduel.required==1" >*</span> -->
          <!-- <span v-if="moduel.required!=1" >选填</span> -->
    </div>

 <!-- <div class='moduel_input'>
   <span style="color:red;"  v-if="moduel.required==1">*</span>
    <span class="demonstration">{{moduel.name}}</span>
    <el-date-picker
    v-if="moduel.key_name == 'start_time'"
    v-model="key_name"
    type="date"
    placeholder="选择日期" :picker-options="pickerOptions_start_time" @change="test1"  start-placeholder="2018-12-20"  @focus="start_time_range">
    <template slot="prepend">{{moduel.name}}</template>
    </el-date-picker>

   <el-date-picker
     v-if="moduel.key_name == 'end_time'"
     v-model="key_name"
     type="date"
     placeholder="选择日期" :picker-options="pickerOptions_end_time" @change="test1"  start-placeholder="2018-12-20"  @focus="end_time_range">
     <template slot="prepend">{{moduel.name}}</template>
   </el-date-picker>
  </div> -->
</template>

<script>
export default {
  name: 'date',
  data () {
    return {
        key_name:'',
        date:'',
        range:'',
        start_time:'',
         aa:this.projectData,
        pickerOptions_end_time:this.processDate(),
        pickerOptions_start_time: {
          disabledDate(time) {
            return time.getTime() <= (Date.now()-24*60*60*1000);
          }
        },
    }
  },
  props: ['moduel', 'projectData','type'],
  methods:{
    time_form(val){
      var end_time = '';
      if(val != null && val != ''){
          var date =  new Date(val);
          var Y = date.getFullYear() + '-';
          var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
          var D = date.getDate() + ' ';
          end_time = Y + M + D;
          console.log(end_time)
      }

      if(isNaN(end_time)&& !isNaN(Date.parse(end_time))){
          this.key_name = end_time;
      }
      
      this.$emit('input', end_time);
      this.$emit('listenToChildEvent',this.type);
    },
    processDate(){//提出结束时间必须大于提出开始时间
      let self = this;
      return {
        disabledDate(time){
          if(self.projectData.start_time){
            return new Date(self.projectData.start_time).getTime() > time.getTime()
          }else{
            return time.getTime() <= (Date.now()-24*60*60*1000);
            //开始时间不选时，结束时间最大值小于等于当天
          }
        }
      }
    },
    processDate_start(){
      let self = this;
      return {
        disabledDate(time){
          if(self.projectData.start_time){
            return new Date(self.projectData.end_time).getTime() < time.getTime() < (Date.now()-24*60*60*1000);
          }else{
            return time.getTime() <= (Date.now()-24*60*60*1000);
            //时间不选时
          }
        }
      }
    },
    end_time_range(){
      this.pickerOptions_end_time =this.processDate();
    },
    start_time_range(){
      this.pickerOptions_start_time =this.processDate_start();
    }
  },
  mounted() {
    // == "string" 
    
    if(this.type == 'edit' && this.projectData[this.moduel.key_name] != ""){
        this.time_form(this.projectData[this.moduel.key_name].slice(0,10));
    }
  },
  watch:{
    'key_name':{
      handler(newName, oldName) {
      },
      immediate: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TimePicker.vue